import { render, staticRenderFns } from "./larChart.vue?vue&type=template&id=65643e66&scoped=true"
import script from "./larChart.vue?vue&type=script&lang=js"
export * from "./larChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-load_f9e102e5cbb5fa5aa7d45569a28cebe6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65643e66",
  null
  
)

export default component.exports